import SnackbarsReducer from '@redux/reducers/snackbars.duck';

import AuthenticationReducer from '@accounts/store/authentication.reducer';
import OnboardingReducer from '@accounts/store/onboarding/Onboarding.duck';

export default {
    onboarding: OnboardingReducer,
    authentication: AuthenticationReducer,
    snackbars: SnackbarsReducer
};
